var map = {
	"./3tochki.svg": "fVYj",
	"./default.svg": "+MJ1",
	"./logo-01.svg": "ikte",
	"./on_air.svg": "aR8K",
	"./pausa_admin-01.svg": "6E35",
	"./pausa_krug-01.svg": "9Fn3",
	"./pausa_menu-01.svg": "xTNK",
	"./pausa_menu.svg": "dtkv",
	"./pausa_menu_mob.svg": "5kBG",
	"./play_admin-01.svg": "ts/U",
	"./play_krug-01.svg": "wwrt",
	"./play_menu-01.svg": "MQZk",
	"./play_podcast-01.svg": "6AzW",
	"./search-01.svg": "aK2u",
	"./strelka-01.svg": "AE2P",
	"./x_admin-01.svg": "CZwb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LcZw";


//////////////////
// WEBPACK FOOTER
// ./public/web/images ^\.\/.*\.svg$
// module id = LcZw
// module chunks = 3 4